import { IExpertiseError, ImGoodAtState, IFlatExpertise } from './State'

export interface IUpdateIndexedItem<T> {
  index: number
  value: T
}

export const SET_EXPERTISE_EDITING_INDEX = 'imGoodAtComponent.setExpertiseEditingIndex'
export const SET_EXPERTISE = 'imGoodAtComponent.setExpertise'

export const SET_EXPERTISE_TITLE = 'imGoodAtComponent.setExpertiseTitle'
export const ADD_NEW_EXPERTISE = 'imGoodAtComponent.addNewExpertise'
export const REMOVE_EXPERTISE = 'imGoodAtComponent.removeExpertise'

export const ADD_NEW_EXPERTISE_TAG = 'imGoodAtComponent.addNewExpertiseTag'
export const REMOVE_EXPERTISE_TAG = 'imGoodAtComponent.removeExpertiseTag'
export const SET_EXPERTISE_TAG = 'imGoodAtComponent.setExpertiseTag'
export const SET_EXPERTISE_TAG_LEVEL = 'imGoodAtComponent.setExpertiseTagLevel'

export const SET_EXPERTISE_ERRORS = 'imGoodAtComponent.setExpertiseErrors'
export const SET_STATE = 'imGoodAtComponent.setState'

export const SET_BECOME_EXPERT_IN_EDITING_INDEX = 'imGoodAtComponent.setBecomeExpertInEditingIndex'
export const SET_BECOME_EXPERT_IN = 'imGoodAtComponent.setBecomeExpertIn'
export const ADD_NEW_BECOME_EXPERT_IN = 'imGoodAtComponent.addNewBecomeExpertIn'
export const REMOVE_BECOME_EXPERT_IN_ITEM = 'imGoodAtComponent.removeBecomeExpertInItem'

export function setExpertiseEditingIndex(payload: number) {
  return {
    type: SET_EXPERTISE_EDITING_INDEX,
    payload
  } as const
}

export function setExpertise(index: number, value: IFlatExpertise) {
  return {
    type: SET_EXPERTISE,
    payload: {
      index,
      value
    } as IUpdateIndexedItem<IFlatExpertise>
  } as const
}

export function setExpertiseTitle(index: number, value: string) {
  return {
    type: SET_EXPERTISE_TITLE,
    payload: {
      index,
      value
    } as IUpdateIndexedItem<string>
  } as const
}

export function addNewExpertise() {
  return {
    type: ADD_NEW_EXPERTISE,
    payload: {}
  } as const
}

export function removeExpertise(payload: number) {
  return {
    type: REMOVE_EXPERTISE,
    payload
  } as const
}

export function setExpertiseErrors(payload: IExpertiseError) {
  return {
    type: SET_EXPERTISE_ERRORS,
    payload
  } as const
}

// --- Expertise tag

export function addNewExpertiseTag(payload: number) {
  return {
    type: ADD_NEW_EXPERTISE_TAG,
    payload
  } as const
}

export function removeExpertiseTag(expertiseIndex: number, tagIndex: number) {
  return {
    type: REMOVE_EXPERTISE_TAG,
    payload: {
      expertiseIndex,
      tagIndex
    } as const
  }
}

export function setExpertiseTag(expertiseIndex: number, tagIndex: number, value: string) {
  return {
    type: SET_EXPERTISE_TAG,
    payload: {
      expertiseIndex,
      tagIndex,
      value
    }
  } as const
}

export function setExpertiseTagLevel(expertiseIndex: number, tagIndex: number, value: number) {
  return {
    type: SET_EXPERTISE_TAG_LEVEL,
    payload: {
      expertiseIndex,
      tagIndex,
      value
    }
  } as const
}

// ---- Set state
export function setState(payload: ImGoodAtState) {
  return {
    type: SET_STATE,
    payload
  }
}

// ---- Become expert in

export function setBecomeExpertIn(index: number, value: string) {
  return {
    type: SET_BECOME_EXPERT_IN,
    payload: {
      index,
      value
    } as IUpdateIndexedItem<string>
  } as const
}

export function setBecomeExpertInEditingIndex(payload: number) {
  return {
    type: SET_BECOME_EXPERT_IN_EDITING_INDEX,
    payload
  } as const
}

export function addNewBecomeExpertIn() {
  return {
    type: ADD_NEW_BECOME_EXPERT_IN,
    payload: {}
  } as const
}

export function removeBecomeExpertInItem(payload: number) {
  return {
    type: REMOVE_BECOME_EXPERT_IN_ITEM,
    payload
  } as const
}

export type ImGoodAtAction = ReturnType<
  | typeof setExpertiseEditingIndex
  | typeof setExpertise
  | typeof setExpertiseTitle
  | typeof addNewExpertise
  | typeof removeExpertise
  | typeof setExpertiseErrors
  | typeof addNewExpertiseTag
  | typeof removeExpertiseTag
  | typeof setExpertiseTag
  | typeof setExpertiseTagLevel
  | typeof setBecomeExpertIn
  | typeof setBecomeExpertInEditingIndex
  | typeof addNewBecomeExpertIn
  | typeof removeBecomeExpertInItem
  | typeof setState
>
